import z from "zod";

export const statisticsSchema = z.object({
  competitorId: z.string().nullish(),
  competitorType: z.enum(["FRANCHISE", "PLAYER"]).nullish(),
  eventStatisticId: z.string().nullish(),
  period: z.number().nullish(),
  periodType: z.string().nullish(),
  type: z.string().nullish(),
  value: z.number().nullish(),
  successfulCompetitorId: z.string().nullish(),
});
